 const list= [
    {
        id: 1,
        img: "screw.jpg",
        tool_name: "Screw",
        price: 870,
        quantity: 1,
        amount:1
    },
    {
        id: 2,
        img: "lock.jpg",
        tool_name: "Godrej Lock",
        price: 290,
        quantity: 1,
        amount:1
    },
    {
        id: 3,
        img: "door-lock-set.jpg",
        tool_name: "Door lock set",
        price: 1600,
        quantity: 1,
        amount:1
    },
    {
        id: 4,
        img: "tower-bolt.jpg",
        tool_name: "Tower bolt",
        price: 540,
        quantity: 1,
        amount:1
    },
    {
        id: 5,
        img: "cabinet-pull-handel.jpg",
        tool_name: "Cabinet pull handel",
        price: 999,
        quantity: "10 piece",
        amount:1
    }
]

export default list;